import { RootState } from 'redux/schemas';
import {
  ComponentKeyPluralized,
  ComponentType,
  NLectureComponent,
  QuestionSetType,
} from 'redux/schemas/models/lecture-component';
import { QuizQuestionType } from 'redux/schemas/models/quiz';
import { getActivityIdFromLectureComponent, getActivityType } from './timeline';

export const getProgressiveQuiz = (
  state: RootState,
  id: number,
) => state.models.progressiveQuizzes[id];

export const getProgressiveQuizQuestion = (
  state: RootState,
  questionId: number,
) => state.models.quizQuestions[questionId];

export const getComponentActivity = (state: RootState, lectureComponent: NLectureComponent<QuestionSetType>) => {
  const activityId = getActivityIdFromLectureComponent(lectureComponent);
  switch (lectureComponent.type) {
    case ComponentType.QUIZ:
      return state.models.quizzes[activityId as number];
    case ComponentType.SURVEY:
      return state.models.surveys[activityId as number];
    case ComponentType.PROGRESSIVE_QUIZ:
      return state.models.progressiveQuizzes[activityId as number];
    default:
      return null;
  }
};

export const getQuestions = (
  state: RootState,
  lectureComponent: NLectureComponent<QuestionSetType>,
) => {
  let displayIndex = 1;
  let quizQuestionsWithDisplayIndex = [];

  const activity = getComponentActivity(state, lectureComponent);
  activity.questions?.forEach((questionId) => {
    if (state.models.quizQuestions[questionId].type !== QuizQuestionType.STATEMENT) {
      quizQuestionsWithDisplayIndex = [
        ...quizQuestionsWithDisplayIndex,
        {
          ...state.models.quizQuestions[questionId],
          displayIndex,
        },
      ];
      displayIndex += 1;
    } else {
      quizQuestionsWithDisplayIndex = [
        ...quizQuestionsWithDisplayIndex,
        {
          ...state.models.quizQuestions[questionId],
          displayIndex: null,
        },
      ];
    }
  });

  return quizQuestionsWithDisplayIndex;
};

export const getQuizQuestionResponse = (
  state: RootState,
  responseId: number,
) => state.models.quizQuestionResponses[responseId] ?? null;

export const getQuizQuestionOption = (
  state: RootState,
  optionId: number,
) => state.models.quizQuestionOptions[optionId] ?? null;

export const getQuizQuestionOptions = (
  state: RootState,
  quizQuestionId: number,
) => state.models.quizQuestions[quizQuestionId]?.responseOptions.map(
  (optionId) => state.models.quizQuestionOptions[optionId],
);

export const getSubmissionQuestionResponse = (
  state: RootState,
  questionId: number,
  questionSetId: number,
  lectureComponentType: ComponentType,
) => state.models[ComponentKeyPluralized[getActivityType(lectureComponentType)]][questionSetId]?.submission?.responses?.filter(
  (eachResponse) => eachResponse.questionId === questionId,
);

export const getQuestionAnswerFeedback = (
  state: RootState,
  questionId: number,
  questionSetId: number,
  lectureComponentType: ComponentType,
) => state.models[ComponentKeyPluralized[getActivityType(lectureComponentType)]][questionSetId]?.submission?.responses?.filter(
  (eachResponse) => eachResponse.questionId === questionId,
)[0]?.feedback;

export const getQuizQuestion = (
  state: RootState,
  questionId: number,
) => state.models.quizQuestions[questionId];
